import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { YouTubeQueryParams } from 'Helper/QueryParams';
import {
    ENGLISH_TUTORIALS_PLAYLIST_ID,
    NORWEGIAN_TUTORIALS_PLAYLIST_ID,
    YOU_TUBE_SEARCH_ENDPOINT,
} from '_constants/youTubeVideo';
import { YouTubeVideosResponse } from '_types/YouTube';
import {
    YouTubeCacheTag,
    YouTubeCacheTagType,
} from '_services/Api/YouTube/YouTubeApiCache';

const YOUTUBE_FIXED_PARAMS =
    'part=snippet&order=date&fields=pageInfo,nextPageToken,items(snippet(resourceId,title,channelTitle,thumbnails))';

export const YouTubeApi = createApi({
    reducerPath: 'youtube/api',
    tagTypes: ['YouTube'],
    keepUnusedDataFor: 60,
    baseQuery: fetchBaseQuery({ baseUrl: YOU_TUBE_SEARCH_ENDPOINT }),
    endpoints: (builder) => ({
        getByPlaylist: builder.query<YouTubeVideosResponse, YouTubeQueryParams>(
            {
                query: ({
                    appLanguage = 'en',
                    maxResults = 5,
                    nextPageToken,
                }: YouTubeQueryParams) => {
                    const playlistId =
                        appLanguage === 'en'
                            ? ENGLISH_TUTORIALS_PLAYLIST_ID
                            : NORWEGIAN_TUTORIALS_PLAYLIST_ID;
                    let params =
                        `key=${process.env.REACT_APP_GOOGLE_YOUTUBE_API_KEY}&` +
                        YOUTUBE_FIXED_PARAMS +
                        `&playlistId=${playlistId}&maxResults=${maxResults}`;
                    if (nextPageToken) {
                        params += `&pageToken=${nextPageToken}`;
                    }
                    return {
                        url: '?' + params,
                    };
                },
                providesTags: (res) => {
                    let idTags: YouTubeCacheTagType[] = [];
                    if (res?.items.length) {
                        idTags = [
                            ...res.items.map(
                                (data) =>
                                    ({
                                        type: 'YouTube',
                                        id: data.snippet.resourceId.videoId,
                                    } as YouTubeCacheTagType),
                            ),
                        ];
                    }
                    return [...idTags, YouTubeCacheTag];
                },
            },
        ),
    }),
});

export const { useGetByPlaylistQuery } = YouTubeApi;
